import React, { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { getEmployeeList, doEmployeeDelete } from "../../../../redux/employee/employeeState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { handleTableChange } from "../../../../utils/index";
import avatar from "assets/img/avatars/user.png";
import Badge from "components/badge";
import EmployeeProfile from "components/card/EmployeeProfile";
import EmployeeInfoForm from "./EmployeeInfoForm";
import PopupButton from "components/button/PopupButton";
import { EMPLOYMENT_STATUS_COLORS, COUNTRY_FLAG_ICONS } from "variables/constants";
import { useSearchParams } from "react-router-dom";


const EmployeeTable = ({  }) => {

	const [searchParams] = useSearchParams();
	const currentPage = searchParams.get("page");
	
	const { getColumnSearchProps } = ColumnSearchFilter();
	const dispatch = useDispatch();
	const recordList = useSelector((state) => state.employee.employeeList?.items);
	const pagination = useSelector((state) =>  state.employee.employeeList?.pagination);
	const filters = useSelector((state) =>  state.employee.employeeList?.filters);
	const requesting = useSelector((state) => state.employee.employeeList?.requesting);
	const error = useSelector((state) => state.employee.employeeList?.error);
	const countryList = useSelector((state) => state.optionlist.countryList?.items);
	const clientList = useSelector((state) => state.optionlist.clientList?.items);
	const employmentStatusList = useSelector((state) => state.optionlist.employmentStatusList?.items);

	const doSearch = (filters) => dispatch(getEmployeeList(filters));
	const doDelete = (id) => dispatch(doEmployeeDelete(id));

  	const columns = [
		{
	        title: `Employee`,
	        dataIndex: 'emp_employee_name',
	        key: 'emp_employee_name',
	        width: '25%',
	        sorter: true,
	        render:(_, record) => (
				<EmployeeProfile
					avatar={avatar}
					record={record}
				/>
			),
	       
	    },
		{
			title: 'Country',
			key: 'emp_country',
			dataIndex: 'emp_country',
			width: '12%',
			sorter: true,
			filters: countryList
				?.filter((country) => country.value !== 'all')
				.map((country) => ({
				text: country.label,
				value: country.value
			})) || [],
			render: (_, record) => {
				const country = record?.user_detail?.address?.country;

				return (
				<div className="flex items-center gap-2">
					{COUNTRY_FLAG_ICONS?.[country?.cou_code] ?? null}
					<span>{country?.cou_name || '-'}</span>
				</div>
				);
			}
		},
		{
			title: (
				<>
					<div>Job Position /</div>
					<div>Hire Date</div>
				</>
			),
			key: 'emp_title',
			dataIndex: 'emp_title',
			width: '15%',  
			sorter: true,
			...getColumnSearchProps('emp_title', 'Search Job Position'),
			render:(_, record) => (
				<>
					<div>{`${record.emp_title ? record.emp_title : '_'}`}</div>
					<div>{`${record.emp_hire_date ? record.emp_hire_date : '_'}`}</div>
				</>
			)
	    },
		{
	        title: `Client`,
	        dataIndex: 'emp_client_id',
	        key: 'emp_client_id',
	        width: '15%',  
	        sorter: true,
			filters: clientList?.map((client) => ({
				text: client.label,
				value: client.value
			})) || [],
	        render:(_, record) => (
				<span>{`${record?.client_name}`}</span>
			),
	    },
	    {
	        title: `Status`,
	        dataIndex: 'emp_employment_status_id',
	        key: 'emp_employment_status_id',
	        width: '14%',
			sorter: true,
			filters: employmentStatusList?.map((employmentStatus) => ({
				text: employmentStatus.label,
				value: employmentStatus.value
			})) || [],
	        render: (_, record) => (
				<Badge color={EMPLOYMENT_STATUS_COLORS[record?.employment_status_name]}>
					<span>{record?.employment_status_name}</span>
				</Badge>
			)
	    },
	    {
	        title: (
				<div className="flex justify-center">
					<PopupButton id="add_employee" title="Add Employee" label="Add" btnClass="btn-small" >
						<EmployeeInfoForm recordId="0" mode="edit"/>
					</PopupButton>
				</div>
			),
	        dataIndex: 'emp_id',
	        key: 'emp_id',
	        width: '14%',
	        render:(emp_id) => <CrudOption baseRoute="/console/employees" recordId={emp_id} deleteHandler={doDelete} allowEdit={false}/>
	    },
    ];

	useEffect(() => {
		dispatch(getEmployeeList({...filters, paginate: pagination.per_page }));
	}, [dispatch]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
			<div className="py-2 mb-2 w-full md:w-1/2">
				<SearchFilter 
					placeholder="Search by Employee Id or Name" 
					searchHandler={doSearch} 
					filters={filters} 
					pagination={pagination}
				/>
			</div>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.emp_id}
					scroll={{ x: "max-content" }}
		        	pagination={{
						current: pagination.current_page || 1,
						pageSize: pagination.per_page || 10,
						total: pagination.total || 0,
						showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,
					}}    
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

export default (EmployeeTable);